import {type RestTypeWithTypename} from '../rest-type-with-typename';
import {
    type EmployeeLeaveSummaryWithIndependentPeriodsResponse,
    type Summary,
} from './employee-leave-summary-with-independent-periods-data';

function mapSummary(summary: Summary): RestTypeWithTypename<Summary> {
    return {
        ...summary,
        __typename: 'Summary',
        leaves: summary.leaves.map(outerleave => {
            return outerleave.map(leave => ({
                __typename: 'Leave',
                ...leave,
                leaveSubType: leave.leaveSubType
                    ? {
                          __typename: 'LeaveSubType',
                          ...leave.leaveSubType,
                      }
                    : leave.leaveSubType,
            }));
        }),
        past: {
            ...summary.past,
            __typename: 'Past',
        },
        period: {
            ...summary.period,
            __typename: 'Period',
        },
        totals: {
            ...summary.totals,
            __typename: 'Totals',
        },
    };
}

export function employeeLeaveSummaryWithIndependentPeriodsTypePatcher(
    data: EmployeeLeaveSummaryWithIndependentPeriodsResponse,
): RestTypeWithTypename<EmployeeLeaveSummaryWithIndependentPeriodsResponse> {
    return {
        __typename: 'EmployeeLeaveSummaryWithIndependentPeriodsData',

        externalBalances: {
            __typename: 'ExternalBalances',
            ...(data.externalBalances ?? {}),
        },
        summaries: {
            __typename: 'Summaries',
            ...(data.summaries ?? {}),
            ABSENT: data.summaries?.ABSENT.map(mapSummary),
            VACATION: data.summaries?.VACATION.map(mapSummary),
            SICK: data.summaries?.SICK.map(mapSummary),
            CHILD_SICK: data.summaries?.CHILD_SICK.map(mapSummary),
        },
        bradfordFactor: {
            __typename: 'BradfordFactor',
            ...data.bradfordFactor,
        },
    };
}
